<template>
    <FieldGroup_k_combobox
        class="address-no-label shipment-edit-group-dropdown"
        :field-group_class="'field-group'"
        :id="'location_coords'+index"
        :label="title"
        :items="locationsSearch"
        :field_value="'name'"
        :field_key="'place_id'"
        :field_group="'group'"
        :error="[]"
        :sortBy="'sort'"
        :filterable="true"
        :disabled="disabled"
        @filterChangeFn="fetchAddress"
        v-model="address"
    />
</template>

<script>
import {useToast} from "vue-toastification";

export default {
    name: "addressSearch",
    emits: ['update:modelValue'],
    props: {
        label: String,
        index: Number,
        disabled: {
            type: Boolean,
            default: () => false
        },
        modelValue: [Object, Array],
    },
    data() {
        return {
            toast: useToast(),
            locationsSearch: []
        }
    },
    computed: {
        title() {
            return this.label || this.$t('text.Address')
        },
        address: {
            get() {
                return this.modelValue
            },
            set(vl) {
                if(vl?.place_id) {
                    this.fetchPlace(vl?.place_id)
                } else {
                    this.locationsSearch = []
                    this.$emit('update:modelValue', {});
                }
            }
        }
    },
    methods: {
        fetchAddress(address) {
            if(!address) {
                this.locationsSearch = []
                return false;
            }
            this.$api.locations.searchAddress({address, language: 'en'})
                .then((response) => {
                    if (!response?.data?.error && !response?.data?.errors) {
                        this.locationsSearch = response?.data?.map(v => ({...v, valueField: v.name}))
                    } else {
                        this.toast.error(response?.data?.error || JSON.stringify(response?.data?.errors))
                    }
                })
                .catch((error) => {
                    console.error(error)
                    this.toast.error(error)
                })

        },
        fetchPlace(place_id) {
            this.$api.locations
                .searchAddressPlace(place_id)
                .then(response => {
                    if (response.status < 400 && (!response.data || !response.data.error)) {
                        let data = response.data
                        this.$emit('update:modelValue', data);
                    } else {
                        this.toast.error(this.$t("success!"))
                        console.error(response)
                    }
                })
        }
    }
}
</script>

<style scoped lang="scss">
.address-no-label {
    &.field-group.field-group_type_combobox {
        &::v-deep(label) {
            display: none;
        }
        &::v-deep(.k-input-inner) {
            padding: 10px;
        }
        &::v-deep(.k-combobox),
        &::v-deep(.k-input-inner){
            height: 2rem;
        }
        &::v-deep(.k-button),
        &::v-deep(.k-clear-value) {
            height: 1rem;
            width: 1rem;
            padding: 0;

            .k-icon,
            &::before {
                background-size: contain;
                width: 90%;
                height: 90%;
            }
        }
        &::v-deep(.k-clear-value){
            right: 2rem;
        }
    }
}
</style>